import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { colors, fonts, moduleColors } from "../theme";
import { View, Text, Card, Button, Press, ScreenHeader, IconTile, ProgressBar } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { useAppState } from "../state";
import { AREAS, lessonsByArea, t } from "../content";

export default function Module() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { tr, lang } = useI18n();
  const { state } = useAppState();
  const areaIdx = AREAS.findIndex((a) => a.id === id);
  const area = AREAS[areaIdx];
  if (!area) return null;
  const mc = moduleColors[areaIdx];
  const lessons = lessonsByArea(area.id);
  const done = lessons.filter((l) => state.lessons[l.id]?.completed).length;

  return (
    <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={`${tr("modules")} ${area.num}`} onBack={() => navigate(-1)} />
      <View style={{ padding: 20 }}>
        <Card style={{ marginBottom: 16 }}>
          <View row style={{ gap: 14, alignItems: "center", marginBottom: 14 }}>
            <IconTile icon={area.icon} tint={mc.tint} accent={mc.accent} size={56} />
            <View style={{ flex: 1, minWidth: 0 }}>
              <Text style={{ fontWeight: fonts.bold, fontSize: 20, color: colors.onSurface }}>{t(area.title, lang)}</Text>
              <Text style={{ fontWeight: fonts.regular, fontSize: 13, color: colors.muted }}>{done}/{lessons.length} {tr("lessons")}</Text>
            </View>
          </View>
          <ProgressBar progress={lessons.length ? (done / lessons.length) * 100 : 0} color={mc.accent} />
          <View style={{ marginTop: 16 }}>
            <Button testID="module-exam-btn" title={`${tr("moduleExams")} · 12 ${tr("questions")}`} variant="secondary" small icon="cap"
              onPress={() => navigate(`/session?mode=exam&examId=module_${area.id}`)} />
          </View>
        </Card>

        {lessons.map((l, i) => {
          const isDone = state.lessons[l.id]?.completed;
          return (
            <Press key={l.id} testID={`lesson-${l.id}`} onClick={() => navigate(`/lesson/${l.id}`)}>
              <Card style={{ flexDirection: "row", alignItems: "center", gap: 14, marginBottom: 10 }}>
                <View style={{ width: 34, height: 34, borderRadius: 17, backgroundColor: isDone ? colors.successSurface : colors.surfaceSecondary, alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  {isDone ? <Icon name="check" size={16} color={colors.success} weight="bold" />
                    : <Text style={{ fontWeight: fonts.bold, fontSize: 13, color: colors.muted }}>{i + 1}</Text>}
                </View>
                <View style={{ flex: 1, minWidth: 0 }}>
                  <Text numberOfLines={2} style={{ fontWeight: fonts.semibold, fontSize: 15, color: colors.onSurface }}>{t(l.title, lang)}</Text>
                  <Text style={{ fontWeight: fonts.regular, fontSize: 12, color: colors.muted, marginTop: 2 }}>{t(l.topic, lang)} · {l.minutes} {tr("min")}</Text>
                </View>
                <Icon name="caret-right" size={18} color={colors.muted} />
              </Card>
            </Press>
          );
        })}
      </View>
    </View>
  );
}
